import { SectionHeader } from "../components/SectionHeader";
import { StatusPill } from "../components/StatusPill";
import { DataTable } from "../components/DataTable";
import { fetchDashboardBridge } from "../lib/dashboard";
import { DashboardStateView, useDashboardQuery } from "../hooks/useDashboardQuery";

export function BridgeStatusPage() {
  const state = useDashboardQuery(fetchDashboardBridge);

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Bridge status</h1>
          <p>Broker connection posture for this tenant. No live broker networking from the dashboard.</p>
        </div>
        <StatusPill label="Read-only" tone="neutral" />
      </div>
      <DashboardStateView
        state={state}
        emptyTitle="No bridge connections"
        emptyDetail="No broker profiles or connections are registered for this tenant."
      >
        {(data) => (
          <>
            <div className="panel">
              <SectionHeader title="Bridge posture" subtitle={`Tenant ${data.tenantId}`} />
              <div className="panel-body kv-grid">
                <div className="kv-item">
                  <div className="k">Bridge mode</div>
                  <div className="v">
                    <StatusPill label={data.bridgeMode} tone="neutral" />
                  </div>
                </div>
                <div className="kv-item">
                  <div className="k">Execution mode</div>
                  <div className="v">{data.executionMode}</div>
                </div>
                <div className="kv-item">
                  <div className="k">Broker profiles</div>
                  <div className="v">{data.brokerCount}</div>
                </div>
                <div className="kv-item">
                  <div className="k">Queue status</div>
                  <div className="v">{data.queueStatus}</div>
                </div>
                <div className="kv-item">
                  <div className="k">Live execution</div>
                  <div className="v">{data.liveExecutionEnabled ? "Enabled" : "Disabled"}</div>
                </div>
              </div>
            </div>
            {data.connections.length > 0 ? (
              <div className="panel" style={{ marginTop: 16 }}>
                <SectionHeader title="Connections" subtitle="Simulation / shadow metadata only" />
                <div className="panel-body" style={{ paddingTop: 0 }}>
                  <DataTable
                    rows={data.connections}
                    rowKey={(r) => r.connectionId}
                    columns={[
                      {
                        key: "id",
                        header: "Connection",
                        render: (r) => <span className="mono">{r.connectionId}</span>,
                      },
                      { key: "broker", header: "Broker", render: (r) => r.brokerId },
                      { key: "provider", header: "Provider", render: (r) => r.provider },
                      { key: "mode", header: "Mode", render: (r) => r.mode },
                      { key: "status", header: "Status", render: (r) => r.status },
                      { key: "health", header: "Health", render: (r) => r.healthStatus },
                    ]}
                  />
                </div>
              </div>
            ) : null}
          </>
        )}
      </DashboardStateView>
    </>
  );
}
